import type { Cable } from '../types';
import { endpointMatchesLayoutPort, parsePortEndpointId } from './portNamingSchemes';

const PV_POLE_MAX_CABLES = 8;

export function maxCablesForPortKind(kind?: string | null): number {
  const k = String(kind || '');
  if (k === 'pvPlus' || k === 'pvMinus') return PV_POLE_MAX_CABLES;
  return 1;
}

export function countCablesOnEndpoint(cables: Cable[], portId: string): number {
  return cables.filter((c) => c.from === portId || c.to === portId).length;
}

export function countCablesOnLayoutPort(
  cables: Cable[],
  equipmentId: string,
  port: { number: number; kind?: string },
  layoutPorts: Array<{ number: number; kind?: string }>
): number {
  return cables.filter(
    (c) =>
      endpointMatchesLayoutPort(c.from, equipmentId, port, layoutPorts) ||
      endpointMatchesLayoutPort(c.to, equipmentId, port, layoutPorts)
  ).length;
}

export function endpointAtCableCapacity(cables: Cable[], portId: string, kind?: string | null): boolean {
  const parsed = parsePortEndpointId(portId);
  const k = kind || parsed?.kind;
  return countCablesOnEndpoint(cables, portId) >= maxCablesForPortKind(k);
}
